import { ELanguage } from '@app/swagger-types';
import { typedEnv } from '@app/environment/typed-env';

/**
 * Per-language cookie-policy pages, hosted on the marketing site (WordPress), not the app - see
 * docs/cookiebanner-app-integratie.md §5. Paths only; REACT_APP_TQ_CONSENT_SITE_URL supplies the
 * host (staging until the WordPress plugin goes live on production, then the real domain).
 */
const COOKIE_POLICY_PATHS: Record<ELanguage, string> = {
  [ELanguage.ENGLISH]: '/cookie-policy/',
  [ELanguage.GERMAN]: '/de/cookie-richtlinie/',
  [ELanguage.DUTCH]: '/nl/cookieverklaring/',
  [ELanguage.SPANISH]: '/es/politica-de-cookies/',
  [ELanguage.FRENCH]: '/fr/politique-de-cookies/',
  [ELanguage.ITALIAN]: '/it/informativa-cookie/',
};

export const getCookiePolicyUrl = (language: ELanguage): string =>
  `${typedEnv.REACT_APP_TQ_CONSENT_SITE_URL}${COOKIE_POLICY_PATHS[language] ?? COOKIE_POLICY_PATHS[ELanguage.ENGLISH]}`;
